import { AbstractEntity } from '../AbstractEntity'
import { queryHistoryFromSender, queryLatestState, queryHistoryFromReceiver, queryLatestStateFromReceiver } from '@/api/seaExport/crossTenantHistory'

export class CrossTenantHistory extends AbstractEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get sendTenantId() {
    return this._data.sendTenantId
  }
  set sendTenantId(sendTenantId) {
    this._data.sendTenantId = sendTenantId || 0
  }
  get sendJobNo() {
    return this._data.sendJobNo
  }
  set sendJobNo(sendJobNo) {
    this._data.sendJobNo = sendJobNo
  }
  get receiveTenantId() {
    return this._data.receiveTenantId
  }
  set receiveTenantId(receiveTenantId) {
    this._data.receiveTenantId = receiveTenantId || 0
  }
  get receiveJobNo() {
    return this._data.receiveJobNo
  }
  set receiveJobNo(receiveJobNo) {
    this._data.receiveJobNo = receiveJobNo
  }
  get state() {
    return this._data.state
  }
  set state(state) {
    this._data.state = state || 0
  }
  get operateDate() {
    return this._data.operateDate
  }
  set operateDate(operateDate) {
    this._data.operateDate = operateDate
  }
  get operatorId() {
    return this._data.operatorId
  }
  set operatorId(operatorId) {
    this._data.operatorId = operatorId || 0
  }
  get remark() {
    return this._data.remark
  }
  set remark(remark) {
    this._data.remark = remark
  }
  get operatorName() {
    return this._data.operatorName
  }
  set operatorName(operatorName) {
    this._data.operatorName = operatorName
  }
  get loadingPortCode() {
    return this._data.loadingPortCode
  }
  set loadingPortCode(loadingPortCode) {
    this._data.loadingPortCode = loadingPortCode
  }
  get destinationPortCode() {
    return this._data.destinationPortCode
  }
  set destinationPortCode(destinationPortCode) {
    this._data.destinationPortCode = destinationPortCode
  }
  get carrierId() {
    return this._data.carrierId
  }
  set carrierId(carrierId) {
    this._data.carrierId = carrierId || 0
  }
  get carrierName() {
    return this._data.carrierName
  }
  set carrierName(carrierName) {
    this._data.carrierName = carrierName
  }
  get ETD() {
    return this._data.ETD
  }
  set ETD(ETD) {
    this._data.ETD = ETD
  }
  get containerInfo() {
    return this._data.containerInfo
  }
  set containerInfo(containerInfo) {
    this._data.containerInfo = containerInfo
  }
  // 发送方查看委托历史
  static async queryHistoryFromSender(sendJobNo) {
    return await queryHistoryFromSender({ sendJobNo }).then(res => res.data)
  }
  // 查询发送方最新的委托状态
  static async queryLatestState(sendJobNo) {
    return await queryLatestState({ sendJobNo }).then(res => res.data)
  }
  // 接收方查看委托历史
  static async queryHistoryFromReceiver(receiveJobNo) {
    return await queryHistoryFromReceiver({ receiveJobNo }).then(res => res.data)
  }
  // 查询接收方最新的委托状态
  static async queryLatestStateFromReceiver(receiveJobNo) {
    return await queryLatestStateFromReceiver({ receiveJobNo }).then(res => res.data)
  }
}
